import { PRE_ALIGNER_DISTRACTION_SPLINT_HELP_TEXT } from "../constants/questionnaire-orcadent-constants";

/**
 * Represents the version of the 'OrcadentQuestionnaireModel'
 * - should be incremented with every change
 */
export const OrcadentQuestionnaireModelVersion = 0;
export interface OrcadentQuestionnaireModel {
	preAlignerDistractionSplint: boolean;
	occlusalHeightInstruction: OptionWithText;
	nonMovingTeeth?: string;
	middleline: {
		uj: OptionWithText;
		lj: OptionWithText;
	};
	anteriorTeeth?: {
		uj: AnteriorTeethOptions;
		lj: AnteriorTeethOptions;
	};
	posteriorTeeth?: {
		q1: PosteriorTeethOptions;
		q2: PosteriorTeethOptions;
		q3: PosteriorTeethOptions;
		q4: PosteriorTeethOptions;
	};
	removeAttachmentsForMovement: {
		uj: OptionWithText;
		lj: OptionWithText;
	};
	attachmentPositionMovement: {
		uj: AttachmentPositionMovementOptions;
		lj: AttachmentPositionMovementOptions;
	};
	ipr: {
		uj: OptionWithText;
		lj: OptionWithText;
	};
	elasticCuts?: string;
	buttonCuts?: string;
	pontics?: {
		half: string;
		full: string;
	};
	eruptionCaps?: {
		q1: boolean;
		q2: boolean;
		q3: boolean;
		q4: boolean;
	};
	individualComments?: string;
	version: number;
}

export type OptionWithText = {
	option: string;
	text?: string;
};

type AnteriorTeethOptions = {
	protrude_retrude: OptionWithText;
	procline_recline: OptionWithText;
	compress_expand: OptionWithText;
	torque: OptionWithText;
};

type PosteriorTeethOptions = {
	distalize_mesialize: OptionWithText;
	compress_expand: OptionWithText;
};

type AttachmentPositionMovementOptions = {
	scheuProtocol: boolean;
	labialBuccal?: string;
	lingualPalatal?: string;
};
export enum Quadrant {
	Q1 = 'q1',
	Q2 = 'q2',
	Q3 = 'q3',
	Q4 = 'q4',
}

export enum ThreeOptionsAnswer{
	YES = "yes",
	NO = "no",
	OTHER = "other"
}

export const RemoveAttachmentsForMovementAnswerRecord: Record<ThreeOptionsAnswer, string> = {
	[ThreeOptionsAnswer.YES]: "Yes, remove all",
	[ThreeOptionsAnswer.NO]: "No",
	[ThreeOptionsAnswer.OTHER]: "Yes, the following",
}

export const IprAnswerRecord: Record<ThreeOptionsAnswer, string> = {
	[ThreeOptionsAnswer.YES]: "Yes",
	[ThreeOptionsAnswer.NO]: "No",
	[ThreeOptionsAnswer.OTHER]: "Yes, between (mm)",
}


export enum OrcadentQuestionnaireSection {
    PRE_ALIGNER_DISTRACTION_SPLINT = "PreAlignerDistractionSplint",
    OCCLUSAL_HEIGHT_INSTRUCTION = "OcclusalHeightInstruction",
    NON_MOVING_TEETH = "NonMovingTeeth",
    MIDDLELINE = "Middleline",
    ANTERIOR_TEETH = "AnteriorTeeth",
    POSTERIOR_TEETH = "PosteriorTeeth",
    REMOVE_ATTACHMENTS_FOR_MOVEMENT = "RemoveAttachmentsForMovement",
    ATTACHMENT_POSITION_MOVEMENT = "PositionAttachmentsForMovement",
    IPR = "IPR",
    ELASTIC_CUTS = "ElasticCuts",
    BUTTON_CUTS = "ButtonCuts",
    PONTICS = "Pontics",
    ERUPTION_CAPS = "EruptionCaps",
    INDIVIDUAL_COMMENTS = "IndividualComments",
}

export interface OrcadentQuestionnaireSectionData {
	headline: string;
	helpText?: { de: string; en: string };
}


export const OrcadentQuestionnaireDataRecord: Record<OrcadentQuestionnaireSection, OrcadentQuestionnaireSectionData> = {
	[OrcadentQuestionnaireSection.PRE_ALIGNER_DISTRACTION_SPLINT]: {
		headline: "PreAlignerDistractionSplintHeader",
		helpText: PRE_ALIGNER_DISTRACTION_SPLINT_HELP_TEXT,
	},
	[OrcadentQuestionnaireSection.OCCLUSAL_HEIGHT_INSTRUCTION]: {
		headline: "OcclusalHeightInstructionHeader"
	},
	[OrcadentQuestionnaireSection.NON_MOVING_TEETH]: {
		headline: "NonMovingTeethHeader"
	},
	[OrcadentQuestionnaireSection.MIDDLELINE]: {
		headline: "MiddlelineHeader"
	},
	[OrcadentQuestionnaireSection.ANTERIOR_TEETH]: {
		headline: "AnteriorTeethHeader"
	},
	[OrcadentQuestionnaireSection.POSTERIOR_TEETH]: {
		headline: "PosteriorTeethHeader"
	},
	[OrcadentQuestionnaireSection.REMOVE_ATTACHMENTS_FOR_MOVEMENT]: {
		headline: "RemoveAttachmentsForMovementHeader"
	},
	[OrcadentQuestionnaireSection.ATTACHMENT_POSITION_MOVEMENT]: {
		headline: "PositionAttachmentsForMovementHeader"
	},
	[OrcadentQuestionnaireSection.IPR]: {
		headline: "IPR"
	},
	[OrcadentQuestionnaireSection.ELASTIC_CUTS]: {
		headline: "Elastic Cuts"
	},
	[OrcadentQuestionnaireSection.BUTTON_CUTS]: {
		headline: "Button Cuts"
	},
	[OrcadentQuestionnaireSection.PONTICS]: {
		headline: "Pontics"
	},
	[OrcadentQuestionnaireSection.ERUPTION_CAPS]: {
		headline: "Eruption Caps"
	},
	[OrcadentQuestionnaireSection.INDIVIDUAL_COMMENTS]: {
		headline: "IndividualCommentsHeader"
	},
}
